{
    "availabilityZones": [
        {
            "azId": 1,
            "color": "#cb512b",
            "height": 52,
            "id": "az-1",
            "label": "AVAILABILITY ZONE 1",
            "width": 39,
            "x": 2.5,
            "y": 30
        },
        {
            "azId": 2,
            "color": "#96e0e4",
            "height": 52,
            "id": "az-2",
            "label": "AVAILABILITY ZONE 2",
            "width": 39,
            "x": 43.5,
            "y": 30
        }
    ],
    "badges": [
        {
            "borderStyle": "solid",
            "borderThickness": 0.14,
            "color": "#cb512b",
            "cornerRadius": 0.35,
            "fillOpacity": 18,
            "fontSize": 0.75,
            "height": 1,
            "id": "az-1-row-1",
            "label": "ROW 1",
            "textColor": "#ffffff",
            "width": 4,
            "x": 10.5,
            "y": 32
        },
        {
            "borderStyle": "solid",
            "borderThickness": 0.14,
            "color": "#cb512b",
            "cornerRadius": 0.35,
            "fillOpacity": 18,
            "fontSize": 0.75,
            "height": 1,
            "id": "az-1-row-2",
            "label": "ROW 2",
            "textColor": "#ffffff",
            "width": 4,
            "x": 29.5,
            "y": 32
        },
        {
            "borderStyle": "solid",
            "borderThickness": 0.14,
            "color": "#96e0e4",
            "cornerRadius": 0.35,
            "fillOpacity": 18,
            "fontSize": 0.75,
            "height": 1,
            "id": "az-2-row-3",
            "label": "ROW 3",
            "textColor": "#ffffff",
            "width": 4,
            "x": 51.5,
            "y": 32
        },
        {
            "borderStyle": "solid",
            "borderThickness": 0.14,
            "color": "#96e0e4",
            "cornerRadius": 0.35,
            "fillOpacity": 18,
            "fontSize": 0.75,
            "height": 1,
            "id": "az-2-row-4",
            "label": "ROW 4",
            "textColor": "#ffffff",
            "width": 4,
            "x": 70.5,
            "y": 32
        }
    ],
    "gridUnitPixels": 20,
    "heightUnits": 84,
    "labels": [],
    "lines": [
        {
            "color": "#cb512b",
            "id": "az-1-row-1-line",
            "style": "dashed",
            "thickness": 0.15,
            "x1": 12.5,
            "x2": 12.5,
            "y1": 33,
            "y2": 81
        },
        {
            "color": "#cb512b",
            "id": "az-1-row-2-line",
            "style": "dashed",
            "thickness": 0.15,
            "x1": 31.5,
            "x2": 31.5,
            "y1": 33,
            "y2": 81
        },
        {
            "color": "#96e0e4",
            "id": "az-2-row-3-line",
            "style": "dashed",
            "thickness": 0.15,
            "x1": 53.5,
            "x2": 53.5,
            "y1": 33,
            "y2": 81
        },
        {
            "color": "#96e0e4",
            "id": "az-2-row-4-line",
            "style": "dashed",
            "thickness": 0.15,
            "x1": 72.5,
            "x2": 72.5,
            "y1": 33,
            "y2": 81
        }
    ],
    "mapId": "small-colo",
    "mapName": "Small Colo",
    "rackSlots": [
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "eddSlotU": 42,
            "id": "small-colo-floor-slot-7",
            "purpose": "uplink",
            "rotation": 0,
            "slot": 7,
            "type": "standing",
            "width": 7,
            "x": 3.5,
            "y": 34
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-6",
            "purpose": "standard",
            "rotation": 0,
            "slot": 6,
            "type": "standing",
            "width": 7,
            "x": 3.5,
            "y": 40
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-5",
            "purpose": "standard",
            "rotation": 0,
            "slot": 5,
            "type": "standing",
            "width": 7,
            "x": 3.5,
            "y": 46
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-4",
            "purpose": "standard",
            "rotation": 0,
            "slot": 4,
            "type": "standing",
            "width": 7,
            "x": 3.5,
            "y": 52
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-15",
            "purpose": "standard",
            "rotation": 0,
            "slot": 15,
            "type": "standing",
            "width": 7,
            "x": 3.5,
            "y": 58
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-14",
            "purpose": "standard",
            "rotation": 0,
            "slot": 14,
            "type": "standing",
            "width": 7,
            "x": 3.5,
            "y": 64
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-13",
            "purpose": "standard",
            "rotation": 0,
            "slot": 13,
            "type": "standing",
            "width": 7,
            "x": 3.5,
            "y": 70
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-12",
            "purpose": "standard",
            "rotation": 0,
            "slot": 12,
            "type": "standing",
            "width": 7,
            "x": 3.5,
            "y": 76
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-0",
            "purpose": "standard",
            "rotation": 0,
            "slot": 0,
            "type": "standing",
            "width": 7,
            "x": 14.5,
            "y": 34
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-1",
            "purpose": "standard",
            "rotation": 0,
            "slot": 1,
            "type": "standing",
            "width": 7,
            "x": 14.5,
            "y": 40
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-2",
            "purpose": "standard",
            "rotation": 0,
            "slot": 2,
            "type": "standing",
            "width": 7,
            "x": 14.5,
            "y": 46
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-3",
            "purpose": "standard",
            "rotation": 0,
            "slot": 3,
            "type": "standing",
            "width": 7,
            "x": 14.5,
            "y": 52
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-8",
            "purpose": "standard",
            "rotation": 0,
            "slot": 8,
            "type": "standing",
            "width": 7,
            "x": 14.5,
            "y": 58
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-9",
            "purpose": "standard",
            "rotation": 0,
            "slot": 9,
            "type": "standing",
            "width": 7,
            "x": 14.5,
            "y": 64
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-10",
            "purpose": "standard",
            "rotation": 0,
            "slot": 10,
            "type": "standing",
            "width": 7,
            "x": 14.5,
            "y": 70
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-11",
            "purpose": "standard",
            "rotation": 0,
            "slot": 11,
            "type": "standing",
            "width": 7,
            "x": 14.5,
            "y": 76
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-23",
            "purpose": "standard",
            "rotation": 0,
            "slot": 23,
            "type": "standing",
            "width": 7,
            "x": 22.5,
            "y": 34
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-22",
            "purpose": "standard",
            "rotation": 0,
            "slot": 22,
            "type": "standing",
            "width": 7,
            "x": 22.5,
            "y": 40
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-21",
            "purpose": "standard",
            "rotation": 0,
            "slot": 21,
            "type": "standing",
            "width": 7,
            "x": 22.5,
            "y": 46
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-20",
            "purpose": "standard",
            "rotation": 0,
            "slot": 20,
            "type": "standing",
            "width": 7,
            "x": 22.5,
            "y": 52
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-31",
            "purpose": "standard",
            "rotation": 0,
            "slot": 31,
            "type": "standing",
            "width": 7,
            "x": 22.5,
            "y": 58
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-30",
            "purpose": "standard",
            "rotation": 0,
            "slot": 30,
            "type": "standing",
            "width": 7,
            "x": 22.5,
            "y": 64
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-29",
            "purpose": "standard",
            "rotation": 0,
            "slot": 29,
            "type": "standing",
            "width": 7,
            "x": 22.5,
            "y": 70
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-28",
            "purpose": "standard",
            "rotation": 0,
            "slot": 28,
            "type": "standing",
            "width": 7,
            "x": 22.5,
            "y": 76
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-16",
            "purpose": "standard",
            "rotation": 0,
            "slot": 16,
            "type": "standing",
            "width": 7,
            "x": 33.5,
            "y": 34
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-17",
            "purpose": "standard",
            "rotation": 0,
            "slot": 17,
            "type": "standing",
            "width": 7,
            "x": 33.5,
            "y": 40
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-18",
            "purpose": "standard",
            "rotation": 0,
            "slot": 18,
            "type": "standing",
            "width": 7,
            "x": 33.5,
            "y": 46
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-19",
            "purpose": "standard",
            "rotation": 0,
            "slot": 19,
            "type": "standing",
            "width": 7,
            "x": 33.5,
            "y": 52
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-24",
            "purpose": "standard",
            "rotation": 0,
            "slot": 24,
            "type": "standing",
            "width": 7,
            "x": 33.5,
            "y": 58
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-25",
            "purpose": "standard",
            "rotation": 0,
            "slot": 25,
            "type": "standing",
            "width": 7,
            "x": 33.5,
            "y": 64
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-26",
            "purpose": "standard",
            "rotation": 0,
            "slot": 26,
            "type": "standing",
            "width": 7,
            "x": 33.5,
            "y": 70
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-27",
            "purpose": "standard",
            "rotation": 0,
            "slot": 27,
            "type": "standing",
            "width": 7,
            "x": 33.5,
            "y": 76
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "eddSlotU": 42,
            "id": "small-colo-floor-slot-39",
            "purpose": "uplink",
            "rotation": 0,
            "slot": 39,
            "type": "standing",
            "width": 7,
            "x": 44.5,
            "y": 34
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-38",
            "purpose": "standard",
            "rotation": 0,
            "slot": 38,
            "type": "standing",
            "width": 7,
            "x": 44.5,
            "y": 40
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-37",
            "purpose": "standard",
            "rotation": 0,
            "slot": 37,
            "type": "standing",
            "width": 7,
            "x": 44.5,
            "y": 46
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-36",
            "purpose": "standard",
            "rotation": 0,
            "slot": 36,
            "type": "standing",
            "width": 7,
            "x": 44.5,
            "y": 52
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-47",
            "purpose": "standard",
            "rotation": 0,
            "slot": 47,
            "type": "standing",
            "width": 7,
            "x": 44.5,
            "y": 58
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-46",
            "purpose": "standard",
            "rotation": 0,
            "slot": 46,
            "type": "standing",
            "width": 7,
            "x": 44.5,
            "y": 64
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-45",
            "purpose": "standard",
            "rotation": 0,
            "slot": 45,
            "type": "standing",
            "width": 7,
            "x": 44.5,
            "y": 70
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-44",
            "purpose": "standard",
            "rotation": 0,
            "slot": 44,
            "type": "standing",
            "width": 7,
            "x": 44.5,
            "y": 76
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-32",
            "purpose": "standard",
            "rotation": 0,
            "slot": 32,
            "type": "standing",
            "width": 7,
            "x": 55.5,
            "y": 34
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-33",
            "purpose": "standard",
            "rotation": 0,
            "slot": 33,
            "type": "standing",
            "width": 7,
            "x": 55.5,
            "y": 40
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-34",
            "purpose": "standard",
            "rotation": 0,
            "slot": 34,
            "type": "standing",
            "width": 7,
            "x": 55.5,
            "y": 46
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-35",
            "purpose": "standard",
            "rotation": 0,
            "slot": 35,
            "type": "standing",
            "width": 7,
            "x": 55.5,
            "y": 52
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-40",
            "purpose": "standard",
            "rotation": 0,
            "slot": 40,
            "type": "standing",
            "width": 7,
            "x": 55.5,
            "y": 58
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-41",
            "purpose": "standard",
            "rotation": 0,
            "slot": 41,
            "type": "standing",
            "width": 7,
            "x": 55.5,
            "y": 64
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-42",
            "purpose": "standard",
            "rotation": 0,
            "slot": 42,
            "type": "standing",
            "width": 7,
            "x": 55.5,
            "y": 70
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-43",
            "purpose": "standard",
            "rotation": 0,
            "slot": 43,
            "type": "standing",
            "width": 7,
            "x": 55.5,
            "y": 76
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-55",
            "purpose": "standard",
            "rotation": 0,
            "slot": 55,
            "type": "standing",
            "width": 7,
            "x": 63.5,
            "y": 34
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-54",
            "purpose": "standard",
            "rotation": 0,
            "slot": 54,
            "type": "standing",
            "width": 7,
            "x": 63.5,
            "y": 40
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-53",
            "purpose": "standard",
            "rotation": 0,
            "slot": 53,
            "type": "standing",
            "width": 7,
            "x": 63.5,
            "y": 46
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-52",
            "purpose": "standard",
            "rotation": 0,
            "slot": 52,
            "type": "standing",
            "width": 7,
            "x": 63.5,
            "y": 52
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-63",
            "purpose": "standard",
            "rotation": 0,
            "slot": 63,
            "type": "standing",
            "width": 7,
            "x": 63.5,
            "y": 58
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-62",
            "purpose": "standard",
            "rotation": 0,
            "slot": 62,
            "type": "standing",
            "width": 7,
            "x": 63.5,
            "y": 64
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-61",
            "purpose": "standard",
            "rotation": 0,
            "slot": 61,
            "type": "standing",
            "width": 7,
            "x": 63.5,
            "y": 70
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-60",
            "purpose": "standard",
            "rotation": 0,
            "slot": 60,
            "type": "standing",
            "width": 7,
            "x": 63.5,
            "y": 76
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-48",
            "purpose": "standard",
            "rotation": 0,
            "slot": 48,
            "type": "standing",
            "width": 7,
            "x": 74.5,
            "y": 34
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-49",
            "purpose": "standard",
            "rotation": 0,
            "slot": 49,
            "type": "standing",
            "width": 7,
            "x": 74.5,
            "y": 40
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-50",
            "purpose": "standard",
            "rotation": 0,
            "slot": 50,
            "type": "standing",
            "width": 7,
            "x": 74.5,
            "y": 46
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-51",
            "purpose": "standard",
            "rotation": 0,
            "slot": 51,
            "type": "standing",
            "width": 7,
            "x": 74.5,
            "y": 52
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-56",
            "purpose": "standard",
            "rotation": 0,
            "slot": 56,
            "type": "standing",
            "width": 7,
            "x": 74.5,
            "y": 58
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-57",
            "purpose": "standard",
            "rotation": 0,
            "slot": 57,
            "type": "standing",
            "width": 7,
            "x": 74.5,
            "y": 64
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-58",
            "purpose": "standard",
            "rotation": 0,
            "slot": 58,
            "type": "standing",
            "width": 7,
            "x": 74.5,
            "y": 70
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-colo-floor-slot-59",
            "purpose": "standard",
            "rotation": 0,
            "slot": 59,
            "type": "standing",
            "width": 7,
            "x": 74.5,
            "y": 76
        }
    ],
    "schema": "uptime-facility-map",
    "version": 2,
    "walls": [
        {
            "id": "small-colo-north",
            "kind": "exterior",
            "x1": 0.5,
            "x2": 84.5,
            "y1": 0.5,
            "y2": 0.5
        },
        {
            "id": "small-colo-east",
            "kind": "exterior",
            "x1": 84.5,
            "x2": 84.5,
            "y1": 0.5,
            "y2": 83.5
        },
        {
            "id": "small-colo-south",
            "kind": "exterior",
            "x1": 0.5,
            "x2": 84.5,
            "y1": 83.5,
            "y2": 83.5
        },
        {
            "id": "small-colo-west",
            "kind": "exterior",
            "x1": 0.5,
            "x2": 0.5,
            "y1": 0.5,
            "y2": 83.5
        },
        {
            "id": "small-colo-office-north",
            "kind": "interior",
            "x1": 19,
            "x2": 66,
            "y1": 7,
            "y2": 7
        },
        {
            "id": "small-colo-office-west",
            "kind": "interior",
            "x1": 19,
            "x2": 19,
            "y1": 7,
            "y2": 20
        },
        {
            "id": "small-colo-office-east",
            "kind": "interior",
            "x1": 66,
            "x2": 66,
            "y1": 7,
            "y2": 20
        },
        {
            "id": "small-colo-office-room-one",
            "kind": "interior",
            "x1": 33,
            "x2": 33,
            "y1": 7,
            "y2": 20
        },
        {
            "id": "small-colo-office-room-two",
            "kind": "interior",
            "x1": 52,
            "x2": 52,
            "y1": 7,
            "y2": 20
        },
        {
            "id": "small-colo-office-south-one-left",
            "kind": "interior",
            "x1": 19,
            "x2": 25,
            "y1": 20,
            "y2": 20
        },
        {
            "id": "small-colo-office-south-one-right",
            "kind": "interior",
            "x1": 28,
            "x2": 33,
            "y1": 20,
            "y2": 20
        },
        {
            "id": "small-colo-office-south-two-left",
            "kind": "interior",
            "x1": 33,
            "x2": 39,
            "y1": 20,
            "y2": 20
        },
        {
            "id": "small-colo-office-south-two-right",
            "kind": "interior",
            "x1": 45,
            "x2": 52,
            "y1": 20,
            "y2": 20
        },
        {
            "id": "small-colo-office-south-three-left",
            "kind": "interior",
            "x1": 52,
            "x2": 56,
            "y1": 20,
            "y2": 20
        },
        {
            "id": "small-colo-office-south-three-right",
            "kind": "interior",
            "x1": 59,
            "x2": 66,
            "y1": 20,
            "y2": 20
        }
    ],
    "widthUnits": 85,
    "zones": [
        {
            "borderOpacity": 65,
            "borderStyle": "solid",
            "borderWidth": 0.125,
            "color": "#36c6b1",
            "fillOpacity": 9,
            "fontSize": 0.8,
            "height": 4,
            "id": "small-colo-ops-console-1",
            "label": "OPS CONSOLE",
            "labelPosition": "center",
            "lineHeight": 1.2,
            "maxLines": 4,
            "maxWidth": 12,
            "width": 15,
            "wrapMode": "none",
            "x": 35,
            "y": 8
        },
        {
            "borderOpacity": 65,
            "borderStyle": "dashed",
            "borderWidth": 0.125,
            "color": "#d9aa2f",
            "fillOpacity": 9,
            "fontSize": 0.8,
            "height": 6.5,
            "id": "small-colo-shipping-zone-1",
            "label": "SHIPPING\nZONE",
            "labelPosition": "center",
            "lineHeight": 1.2,
            "maxLines": 4,
            "maxWidth": 12,
            "width": 8,
            "wrapMode": "none",
            "x": 76,
            "y": 13.5
        },
        {
            "borderOpacity": 65,
            "borderStyle": "dashed",
            "borderWidth": 0.125,
            "color": "#e95b55",
            "fillOpacity": 9,
            "fontSize": 0.8,
            "height": 3.5,
            "id": "small-colo-sell-zone-1",
            "label": "SELL\nZONE",
            "labelPosition": "center",
            "lineHeight": 1.2,
            "maxLines": 4,
            "maxWidth": 12,
            "width": 5,
            "wrapMode": "none",
            "x": 46,
            "y": 20
        }
    ]
}
